import React, { useState } from "react";
import {
	Button,
	Col,
	Container,
	Form,
	Row,
	Table,
	Accordion,
} from "react-bootstrap";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";
import NetworkForm from "./NetworkForm";
import Header from "../../componets/Header";
import { FaCircleArrowLeft } from "react-icons/fa6";

function Component(props) {
	const navaigate = useNavigate();
	const { networks, chainConfigs } = useLoaderData();
	const [disabledButton, setDisabledButton] = useState(null);
	const [network, setNetwork] = useState(null);
	const [chainConfig, setChainConfig] = useState(null);
	const [isShowForm, setIsShowForm] = useState(false);
	const [isDisabledFields, setIsDisabledFields] = useState(false);
	const [activeKey, setActiveKey] = useState(null);

	const closeModal = () => {
		setIsShowForm(false);
		setNetwork(null);
	};

	//#region Networks
	const getNetworkPlatformByid = networkId => {
		if (!networkId) {
			return false;
		}
		setIsDisabledFields(true);
		ApiService.getNetworkPlatformByid(networkId)
			.then(response => {
				if (response && response.data) {
					setNetwork(response.data);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				setIsDisabledFields(false);
			});
	};

	const deleteNetworkPlatform = id => {
		setDisabledButton(id);
		AlertService.alertConfirm("Are you sure ?")
			.then(res => {
				ApiService.deleteNetworkPlatform(id)
					.then(response => {
						AlertService.alert("success", "Data seved");
						navaigate("/network-platforms");
					})
					.catch(error => AlertService.alert("error", error))
					.finally(() => {
						setDisabledButton(null);
					});
			})
			.catch(error => {
				AlertService.alert("error", error);
			})
			.finally(() => {
				setDisabledButton(null);
			});
	};

	const updateNetworkPlatform = updatedItem => {
		if (!updatedItem) {
			return false;
		}
		setIsDisabledFields(true);
		ApiService.updateNetworkPlatform(updatedItem)
			.then(response => {
				navaigate("/network-platforms");
				AlertService.alert("success", "Data saved");
			})
			.catch(error => {
				AlertService.alert("error", error);
			})
			.finally(() => {
				setIsDisabledFields(false);
			});
	};

	const renderTableNetworksBody = (items, name, key) => {
		return (
			<React.Fragment key={key}>
				<tbody key={key}>
					{items?.map((item, index) => (
						<tr key={item.id}>
							<th scope="row" className="text-center">
								{index + 1}
							</th>
							<td>
								<span
									style={{
										minWidth: "220px",
										maxWidth: "220px",
									}}
									className="max-line-1"
									title={item.name}>
									{item.name}
								</span>
							</td>
							<td>
								<span
									style={{
										minWidth: "400px",
										maxWidth: "400px",
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
									className="max-line-1"
									title={item.apiKey}>
									{item.apiKey}
								</span>
							</td>
							<td>
								<span
									style={{
										minWidth: "200px",
										maxWidth: "200px",
									}}
									className="max-line-1"
									title={item.networkType}>
									{item.networkType}
								</span>
							</td>
							<td
								className="text-center"
								style={{ color: item.isActive ? "green" : "red" }}>
								<Form.Check
									type="switch"
									className="position-relative"
									id={`isActive-${item.id}`}
									checked={item.isActive}
									disabled={isDisabledFields}
									onChange={e => {
										const updatedItem = { ...item, isActive: e.target.checked };
										updateNetworkPlatform(updatedItem);
									}}
								/>
							</td>
							<td>
								<div className="d-flex gap-2">
									<Link
										to={`/network-platform-view/${item.id}`}
										type="button"
										className="btn btn-success btn-sm px-3">
										View
									</Link>
									<Button
										variant="primary"
										size="sm"
										className="px-3"
										disabled={item.id === disabledButton || isDisabledFields}
										onClick={() => {
											getNetworkPlatformByid(item.id);
										}}>
										Edit
									</Button>
									<Button
										variant="danger"
										size="sm"
										className="px-3"
										disabled={item.id === disabledButton}
										onClick={() => {
											deleteNetworkPlatform(item.id);
										}}>
										Delete
									</Button>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</React.Fragment>
		);
	};
	//#endregion

	//#region Scanners
	const getChainConfigByid = chainConfigId => {
		if (!chainConfigId) {
			return false;
		}
		setIsDisabledFields(true);
		ApiService.getChainConfig(chainConfigId)
			.then(response => {
				if (response && response.data) {
					setChainConfig(response.data);
				}
			})
			.catch(error => AlertService.alert("error", error))
			.finally(() => {
				setIsDisabledFields(false);
			});
	};

	const updateChainConfig = updatedItem => {
		if (!updatedItem) {
			return false;
		}
		setIsDisabledFields(true);
		ApiService.updateChainConfig(updatedItem)
			.then(response => {
				navaigate("/network-platforms"); //es a mnacel poxem
				AlertService.alert("success", "Data saved");
			})
			.catch(error => {
				AlertService.alert("error", error);
			})
			.finally(() => {
				setIsDisabledFields(false);
			});
	};

	const deleteChainConfig = id => {
		setDisabledButton(id);
		AlertService.alertConfirm("Are you sure ?")
			.then(res => {
				ApiService.deleteChainConfig(id)
					.then(response => {
						AlertService.alert("success", "Data seved");
						navaigate("/network-platforms"); //es el piti poxvi
					})
					.catch(error => AlertService.alert("error", error))
					.finally(() => {
						setDisabledButton(null);
					});
			})
			.catch(error => {
				AlertService.alert("error", error);
			})
			.finally(() => {
				setDisabledButton(null);
			});
	};

	const renderTableScannersBody = (items, name, key) => {
		return (
			<React.Fragment key={key}>
				<tbody key={key}>
					{items?.map((item, index) => (
						<tr key={item.id}>
							<th scope="row" className="text-center">
								{index + 1}
							</th>
							<td>
								<span
									style={{
										minWidth: "220px",
										maxWidth: "220px",
									}}
									className="max-line-1"
									title={item.chainName}>
									<img
										className="me-2"
										src={item.chainLogo}
										style={{
											width: 20,
											height: 20,
											objectFit: "contain",
										}}
										alt="logo"
									/>
									{item.chainName}
								</span>
							</td>
							<td>
								<span
									style={{
										minWidth: "400px",
										maxWidth: "400px",
										whiteSpace: "nowrap",
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
									className="max-line-1"
									title={item.currencySlug}>
									<img
										className="me-2"
										src={item.currencyLogo}
										style={{
											width: 20,
											height: 20,
											objectFit: "contain",
										}}
										alt="logo"
									/>
									{item.currencySlug}
								</span>
							</td>
							<td>
								<span
									style={{
										minWidth: "200px",
										maxWidth: "200px",
									}}
									className="max-line-1"
									title={item.platformName}>
									{item.platformName}
								</span>
							</td>
							<td>
								<span
									style={{
										minWidth: "200px",
										maxWidth: "200px",
									}}
									className="max-line-1"
									title={item.apiUrl}>
									{item.apiUrl}
								</span>
							</td>
							<td>
								<span
									style={{
										minWidth: "200px",
										maxWidth: "400px",
									}}
									className="max-line-1"
									title={item.apiKey}>
									{item.apiKey}
								</span>
							</td>
							<td
								className="text-center"
								style={{ color: item.isActive ? "green" : "red" }}>
								<Form.Check
									type="switch"
									className="position-relative"
									id={`isActive-${item.id}`}
									checked={item.isActive}
									disabled={isDisabledFields}
									onChange={e => {
										const updatedItem = { ...item, isActive: e.target.checked };
										updateChainConfig(updatedItem);
									}}
								/>
							</td>

							<td>
								<div className="d-flex gap-2">
									<Link
										to={`/chain-config-view/${item.id}`}
										type="button"
										className="btn btn-success btn-sm px-3">
										View
									</Link>
									{/* <Button
										variant="primary"
										size="sm"
										className="px-3"
										disabled={item.id === disabledButton || isDisabledFields}
										onClick={() => {
											getChainConfigByid(item.id);
										}}>
										Edit
									</Button> */}
									<Button
										variant="danger"
										size="sm"
										className="px-3"
										disabled={item.id === disabledButton}
										onClick={() => {
											deleteChainConfig(item.id);
										}}>
										Delete
									</Button>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</React.Fragment>
		);
	};
	//#endregion

	return (
		<div className="network_platforms">
			<Header>
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex gap-2 align-items-center">
						<Link to="/">
							<FaCircleArrowLeft size={20} />
						</Link>
						<h4 className="mb-0">Network platforms</h4>
					</div>
				</div>
			</Header>
			<Accordion activeKey={activeKey} onSelect={key => setActiveKey(key)}>
				{/* NETWORKS */}
				<Accordion.Item eventKey="0">
					<Accordion.Header>
						<div className="d-flex justify-content-between align-items-center w-100 pe-3">
							<h5 className="mb-0">Networks</h5>

							<button
								className="btn btn-primary btn-sm"
								onClick={e => {
									e.stopPropagation();
									setIsShowForm(true);
								}}>
								+ Add network
							</button>
						</div>
					</Accordion.Header>

					<Accordion.Body className="">
						<Row className="pb-4">
							{networks &&
								Object.entries(networks).map(([key, value], index) => (
									<Col key={index} sm={12} className="mb-4">
										<div className="card shadow-sm border-0">
											{/* HEADER */}
											<div className="card-header bg-light d-flex justify-content-between align-items-center">
												<div className="d-flex align-items-center gap-2">
													<span className="fw-semibold">{key}</span>

													<span className="badge bg-secondary">
														{value.length}
													</span>
												</div>

												{/* можно добавить действия */}
												<span className="text-muted small">Networks</span>
											</div>

											{/* BODY */}
											<div className="card-body p-0">
												<div
													style={{ maxHeight: 400, overflowY: "auto" }}
													className="table-responsive">
													<Table
														bordered
														striped
														hover
														size="sm"
														className="mb-0 align-middle">
														<thead className="table-light position-sticky top-0">
															<tr>
																<th
																	style={{ width: 40 }}
																	className="text-center">
																	#
																</th>
																<th style={{ width: 220 }}>Name</th>
																<th style={{ width: 400 }}>Api key</th>
																<th
																	style={{ width: 200 }}
																	className="text-center">
																	Network Type
																</th>
																<th
																	style={{ width: 85 }}
																	className="text-center">
																	Active
																</th>
																<th
																	style={{ width: 250 }}
																	className="text-center">
																	Action
																</th>
															</tr>
														</thead>

														{renderTableNetworksBody(value, key, index)}
													</Table>
												</div>
											</div>
										</div>
									</Col>
								))}
						</Row>
					</Accordion.Body>
				</Accordion.Item>

				{/* Chains */}
				<Accordion.Item eventKey="1">
					<Accordion.Header>
						<div className="d-flex justify-content-between align-items-center w-100 pe-3">
							<h5 className="mb-0">Chains</h5>

							{/* <button
								className="btn btn-primary btn-sm"
								onClick={e => {
									e.stopPropagation();
									// setIsShowScannerForm(true);
								}}>
								+ Add scanner
							</button> */}
						</div>
					</Accordion.Header>

					<Accordion.Body className="w-100">
						<Row className="pb-4">
							{chainConfigs &&
								Object.entries(chainConfigs).map(([key, value], index) => (
									<Col key={index} sm={12} className="mb-4">
										<div className="card shadow-sm border-0">
											{/* HEADER */}
											<div className="card-header bg-light d-flex justify-content-between align-items-center">
												<div className="d-flex align-items-center gap-2">
													<span className="fw-semibold">{key}</span>

													<span className="badge bg-secondary">
														{value.length}
													</span>
												</div>

												<span className="text-muted small">Scanners</span>
											</div>

											{/* BODY */}
											<div className="card-body p-0">
												<div
													style={{ maxHeight: 400, overflowY: "auto" }}
													className="table-responsive">
													<Table
														bordered
														striped
														hover
														size="sm"
														className="mb-0 align-middle">
														<thead className="table-light position-sticky top-0">
															<tr>
																<th
																	style={{ width: 40 }}
																	className="text-center">
																	#
																</th>
																<th style={{ width: 220 }}>Name</th>
																<th style={{ width: 400 }}>Currency</th>
																<th
																	style={{ width: 200 }}
																	className="text-center">
																	Network Type
																</th>
																<th style={{ width: 220 }}>Api url</th>
																<th style={{ width: 400 }}>Api key</th>
																<th
																	style={{ width: 85 }}
																	className="text-center">
																	Active
																</th>
																<th
																	style={{ width: 250 }}
																	className="text-center">
																	Action
																</th>
															</tr>
														</thead>
														{renderTableScannersBody(value, key, index)}
													</Table>
												</div>
											</div>
										</div>
									</Col>
								))}
						</Row>
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>
			<NetworkForm
				closeModal={closeModal}
				network={network}
				isShowForm={isShowForm}
			/>
		</div>
	);
}

const loader = async () => {
	try {
		const networks = await ApiService.getNetworkPlatforms()
			.then(response => {
				if (response.data && response.data.length) {
					const tableData = {};

					response.data.forEach(item => {
						if (!tableData.hasOwnProperty(item.networkType)) {
							tableData[item.networkType] = response.data
								.filter(el => el.networkType === item.networkType)
								.sort((a, b) => a.name.localeCompare(b.name));
						}
					});
					const sortedObj = Object.keys(tableData)
						.sort()
						.reduce((acc, key) => {
							acc[key] = tableData[key];
							return acc;
						}, {});

					return sortedObj;
				} else {
					return [];
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});

		const chainConfigs = await ApiService.getAllChainConfig()
			.then(response => {
				if (response.data && response.data.length) {
					const tableData = {};

					response.data.forEach(item => {
						if (!tableData.hasOwnProperty(item.platformName)) {
							tableData[item.platformName] = response.data
								.filter(el => el.platformName === item.platformName)
								.sort((a, b) => a.chainName.localeCompare(b.chainName));
						}
					});
					const sortedObj = Object.keys(tableData)
						.sort()
						.reduce((acc, key) => {
							acc[key] = tableData[key];
							return acc;
						}, {});

					return sortedObj;
				} else {
					return [];
				}
			})
			.catch(error => {
				AlertService.alert("error", error);
			});

		return { networks: networks || [], chainConfigs: chainConfigs || [] };
	} catch (error) {
		AlertService.alert("error", error);
		return error;
	}
};

const NetworkPlatforms = Object.assign(Component, { loader });

export default NetworkPlatforms;
